import { API } from 'aws-amplify';
import { useLoaderData } from "react-router-dom";
import { styled } from 'styled-components';
import { getIncident } from '../graphql';
import Container from "./Container";
import Footer from './Footer';
import { List, ListItem, ListItemHeader, ListItemNumber } from './List';
import Media, { MediaContainer } from './Media';
import { H1, P, Subheading } from "./Typography";
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import icon from '../assets/icon-square.svg';

export const reportLoader = async ({ params }) => {
    const { data } = await API.graphql({
        query: getIncident,
        variables: {
            id: params.incidentId,
        },
        authMode: 'API_KEY',
    })
    return data.getIncident;
}

const ReportContents = styled.div`
    padding: 1rem 0 1rem 3rem;
`

const ReportRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

const ScreenReport = () => {
    const report = useLoaderData();
    if (!report) {
        return "Nothing to see here"
    }

    const victims = report.evidence.items.filter(e => e.type === 'VICTIM' && e.status === "APPROVED");
    const witnesses = report.evidence.items.filter(e => e.type === 'WITNESS' && e.status === "APPROVED");

    const printName = (user, anonymous, v) => {
        console.log(v);
        if (anonymous) {
            return "Anonymous"
        } else {
            return `${user.firstName} ${user.lastName}`
        }
    }

    const renderList = (list, type = 'Victim') => {
        return (
            <List style={{ marginTop: '2rem' }}>
                {
                    list.map((v, i) => (
                        <ListItem key={v.id}>
                            <ListItemHeader><ListItemNumber>{i + 1}</ListItemNumber> {type}</ListItemHeader>
                            <ReportContents>

                                <Subheading>Name</Subheading>
                                <P>{printName(v.user, v.anonymous, v)}</P>
                                <Subheading>Date & Time</Subheading>
                                <P>{moment(v.date).format("YYYY-MM-DD [at] h:mm a")}</P>
                                <Subheading>Description</Subheading>
                                <P>{v.description}</P>
                                <Subheading>Media</Subheading>
                                <MediaContainer>
                                    {v.media.items.map(media => <Media key={media.id} media={media} />)}
                                </MediaContainer>
                            </ReportContents>
                        </ListItem>
                    ))
                }
            </List>
        )
    }

    return (
        <Container>
            <img src={icon} style={{ width: '75px' }} />
            <ReportRow>
                <H1>Incident Report</H1>
                <div>
                    <Subheading>Date Printed</Subheading>
                    <P>{moment().format("YYYY-MM-DD [at] h:mm a")}</P>
                </div>

            </ReportRow>
            <div>
                <Subheading>Name</Subheading>
                <P>{report.name}</P>
            </div>
            <ReportRow>
                <div>
                    <Subheading>Incident Date & Time</Subheading>
                    <P>{moment(report.date).format("YYYY-MM-DD [at] h:mm a")}</P>
                </div>
                <div>
                    <Subheading>Location</Subheading>
                    <P>{report.lat}, {report.lng}</P>
                </div>
                <div>
                    <Subheading>Incident Type</Subheading>
                    <P>{report.type.name}</P>
                </div>
            </ReportRow>
            {renderList(victims)}

            {
                witnesses.length > 0 && <>
                    <H1>Witnesses</H1>
                    {renderList(witnesses, 'Witness')}
                </>
            }
            <Footer />
        </Container>
    )
};

export default ScreenReport;